import { useEffect, useRef, useState } from "react";

/**
 * v0.18.0 — gráficos e mapa em SVG encolhem para caber na tela (ex.: 640 → ~340 no celular) e os textos encolhiam
 * junto (5–6px na tela). Este hook mede a largura real e devolve `k` = largura do viewBox ÷ largura na tela (≥ 1,
 * no máximo 2,4). No CSS os textos usam `calc(12px * var(--k, 1))`: ficam com 12px na tela em qualquer largura.
 * Uso: const [ref, k] = useSvgScale(W); <svg ref={ref} style={svgScaleStyle(k)} viewBox=...>
 */
export function useSvgScale(viewBoxWidth: number) {
  const ref = useRef<SVGSVGElement>(null);
  const [k, setK] = useState(1);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => {
      const w = el.getBoundingClientRect().width;
      if (w > 0) setK(Math.min(2.4, Math.max(1, Math.round((viewBoxWidth / w) * 100) / 100)));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [viewBoxWidth]);
  return [ref, k] as const;
}

export const svgScaleStyle = (k: number) => ({ ["--k" as string]: k });
